//#region Fund Streams

import { DataSourceEnum, EntityTypeEnum } from '../../enums/entity.enum';
import {
  StoreModel,
  StoreModelDate,
  StoreModelType,
} from '@aksia/infrastructure';
import { TDatacizeStream } from '../../types/datacize-stream.type';
import {
  IAdministratorVerifications,
  ICounterpartiesCompact,
  IDatacizePoint,
  IInternalCapital,
  IInvestorConcentration,
  IInvestorType,
  ILiquidity,
  IMarketCapNav,
  IOwnership,
  IStaffing,
} from '../../interfaces/datacize-stream/datacize-stream.interface';

export class DatacizePoint extends StoreModel implements IDatacizePoint {
  isAnyFigureRegistered?: boolean;
  entityId?: number;

  @StoreModelType(() => StoreModelDate)
  asOfDate?: string;
}

//#region Asset/Liability Management

export class InvestorType extends DatacizePoint implements IInvestorType {
  pensionFunds?: number;
  sovereignWealthFunds?: number;
  endowmentsFoundations?: number;
  insurance?: number;
  familyOffices?: number;
  fundOfFunds?: number;
  privateBanks?: number;
  other?: number;
}

export class InvestorConcentration
  extends DatacizePoint
  implements IInvestorConcentration
{
  topOne?: number;
  topThree?: number;
  topFive?: number;
  topTen?: number;
}

export class InternalCapital extends DatacizePoint implements IInternalCapital {
  firm?: number;
  fund?: number;
}

//#endregion

//#region Investments

export class Liquidity extends DatacizePoint implements ILiquidity {
  id?: number;
  from?: number;
  fromType?: string;
  to?: number;
  toType?: string;
  percentageOfPortfolio?: number;
}

export class MarketCapNav extends DatacizePoint implements IMarketCapNav {
  megaLong?: number;
  largeLong?: number;
  midLong?: number;
  smallLong?: number;
  microLong?: number;
  indicesOtherLong?: number;
  megaShort?: number;
  largeShort?: number;
  midShort?: number;
  smallShort?: number;
  microShort?: number;
  indicesOtherShort?: number;
}

//#endregion

//#region NAV Calculation

export class AdministratorVerifications
  extends DatacizePoint
  implements IAdministratorVerifications
{
  existenceConfirmedIndependently?: number;
  existenceNotConfirmedIndependently?: number;
  independentlyPricedPositions?: number;
  nonIndependentlyPricedPositions?: number;
}

//#endregion

//#region Counterparties

export class CounterpartiesCompact
  extends DatacizePoint
  implements ICounterpartiesCompact
{
  counterpartyId?: number;
  typeIds?: Array<number>;
  exposure?: number;
}

//#endregion

//#region Management Company Streams

//#region Staffing

export class Staffing extends DatacizePoint implements IStaffing {
  totalStaff?: number;
  investmentEmployees?: number;
  nonInvestmentEmployees?: number;
  investmentHires?: number;
  nonInvestmentHires?: number;
  investmentDepartures?: number;
  nonInvestmentDepartures?: number;
}

//#endregion

//#region Organizational Structure

export class Ownership extends DatacizePoint implements IOwnership {
  internalEquity?: number;
  internalVoting?: number;
  externalEquity?: number;
  externalVoting?: number;
}

//#endregion

//#endregion

export class DatacizeStream extends StoreModel {
  entityId?: number;
  entityTypeId?: EntityTypeEnum;
  streamType?: TDatacizeStream;

  @StoreModelType(() => StoreModelDate)
  dataAsOfDate?: Date;

  dataSource?: DataSourceEnum;
  datapoints?: Array<DatacizePoint>;

  @StoreModelType(() => StoreModelDate)
  selectedAsOf?: Date;

  @StoreModelType(() => StoreModelDate)
  minAsOf?: Date;

  @StoreModelType(() => StoreModelDate)
  maxAsOf?: Date;
}
